// src/services/interestService.js
import apiClient from "./apiClient";

const endpoints = { base: "/admin/interest" };

// Use backend-accepted values only
const normalizeStatus = (s) => {
  const t = String(s || "").toLowerCase();
  return t === "publish" ? "Publish" : "Unpublish";
};

// GET: /admin/interest
export async function getAllInterests({ signal } = {}) {
  const res = await apiClient.get(endpoints.base, { signal });
  return res.data; // { statusCode, success, message, data:[...] }
}

// POST: /admin/interest (create)
export async function addInterest({ name, status, iconFile }, { signal } = {}) {
  const fd = new FormData();
  fd.set("name", name);
  fd.set("status", normalizeStatus(status));
  if (iconFile instanceof File) fd.append("icon", iconFile, iconFile.name);

  // DO NOT set Content-Type; browser sets multipart boundary
  const res = await apiClient.post(endpoints.base, fd, { signal });
  return res.data;
}

// PUT: /admin/interest (update) — ALWAYS send real PUT, even with file
// Send only changed keys if you want (backend still needs "id")
export async function updateInterestPartial(
  { id, name, status, iconFile },
  { signal } = {}
) {
  const fd = new FormData();
  // backend expects "id"
  fd.set("id", id);

  if (typeof name !== "undefined") fd.set("name", name);
  if (typeof status !== "undefined") fd.set("status", normalizeStatus(status));
  if (iconFile instanceof File) fd.append("icon", iconFile, iconFile.name);

  // ✅ REAL PUT (no _method override)
  const res = await apiClient.put(endpoints.base, fd, { signal });
  return res.data;
}

// DELETE: /admin/interest (with JSON body)
export async function deleteInterest({ id }, { signal } = {}) {
  const res = await apiClient.delete(endpoints.base, { signal, data: { id } });
  return res.data;
}
